'use strict';
var parent = require('../../stable/symbol/iterator');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/actual/symbol/iterator.js
// module id = 552
// module chunks = 13